<template>
    <div style="background:#fff;">
        <v-container fluid class="banner-2">
            <v-container>
                <v-row class="mt-8">
                    <v-col cols="12" sm="12" md="7">
                        

                        <h1 v-if="$vuetify.breakpoint.mdAndUp" class="rfont-40 weight-semibold white--text" style="line-height:1.3;">
                            Take online Doctor<br>consultation
                        </h1>
                        <h1 v-else class="text-center rfont-40 weight-semibold white--text" style="line-height:1.3;">
                            Take online Doctor consultation
                        </h1>
                        <h6 class="text-center text-md-left rfont-22 weight-medium white--text mt-5" style="line-height:1.5;">
                            Video consultations with certified doctors across whole India, 24*7 availabilty of doctors from all specialities which you can choose according to your relevancy.
                        </h6>
                        <div class="mt-8 d-md-flex"
                        v-if="$vuetify.breakpoint.mdAndUp"
                        >
                            <span class="d-inline-flex align-center px-3 py-1 rounded"
                                style="background-color:#EAF4FF;min-height:34px;"
                            >
                                <v-img
                                    width="16"
                                    src="/general/ic_banner_check.png"                                                                     
                                ></v-img>
                                <span                                
                                    class="rfont-16 weight-medium ml-2"
                                >
                                    Verified Doctors
                                </span>
                            </span>

                            <span class="d-inline-flex align-center px-3 py-1 rounded ml-2"
                                style="background-color:#EFFFEF;min-height:34px;"
                            >
                                <v-img
                                    width="16"
                                    src="/general/ic_speech.png"                                                                     
                                ></v-img>
                                <span                                
                                    class="rfont-16 weight-medium ml-2"
                                >Free Followup</span>
                            </span>

                            <span class="d-inline-flex align-center px-3 py-1 rounded ml-2"
                                style="background-color:#FFF3F3;min-height:34px"
                            >
                                <v-img
                                    width="16"
                                    aspect-ratio
                                    src="/general/ic_prescription.png"                                                                     
                                ></v-img>
                                <span                                
                                    class="rfont-16 weight-medium ml-2"
                                >Digital Prescription</span>
                            </span>
                        </div>

                        <div class="mt-6 emulated-flex-gap justify-center"
                            v-else                        
                            style="display:inline-flex;flex-wrap:wrap;width:100%;"
                        >
                            <span class="d-inline-flex align-center px-2 py-1 rounded"
                                style="background-color:#EAF4FF;min-height:34px;"
                            >
                                <v-img
                                    width="12"
                                    src="/general/ic_banner_check.png"                                                                     
                                ></v-img>
                                <span                                
                                    class="rfont-12 weight-medium ml-2"
                                >
                                    Verified Doctors
                                </span>
                            </span>

                            <span class="d-inline-flex align-center px-2 py-1 rounded"
                                style="background-color:#EFFFEF;min-height:34px;"
                            >
                                <v-img
                                    width="12"
                                    src="/general/ic_speech.png"                                                                     
                                ></v-img>
                                <span                                
                                    class="rfont-12 weight-medium ml-2"
                                >Free Followup</span>
                            </span>

                            <span class="d-inline-flex align-center px-2 py-1 rounded"
                                style="background-color:#FFF3F3;min-height:34px"
                            >
                                <v-img
                                    width="12"
                                    aspect-ratio
                                    src="/general/ic_prescription.png"                                                                     
                                ></v-img>
                                <span                                
                                    class="rfont-12 weight-medium ml-2"
                                >Digital Prescription</span>
                            </span>
                        </div>
                                             
                        <div class="mt-6 d-flex justify-center justify-md-start">
                            <v-btn color="#D7F6FD" class="secondaryVariant--text weight-semibold rfont-14 mt-5" large flat @click="$router.push({name: 'searchDoctor', query:{video:1}})">
                                Consult Online Now
                            </v-btn>
                        </div>

                    </v-col>

                
                </v-row>
            </v-container>
        </v-container>

        <v-container fluid class="mt-12 px-0" >
            <v-container fluid class="px-0">
                <v-row class="home-rows" align="center">
                    <v-col cols="12" sm="12" md="12" class="text-center">
                        <h1 class="rfont-32 darkergray--text playfair-display weight-semibold">How it works</h1>                        
                    </v-col>
                    <v-col style="margin-top:-130px;" v-if="$vuetify.breakpoint.mdAndUp">
                         <v-img                                          
                            contain
                            class="mt-6"
                            src="/general/how-it-works-v2.png"                                                                                                 
                        ></v-img>
                    </v-col>                           
                </v-row>
                <div style="position:relative;" v-if="$vuetify.breakpoint.smAndDown">
                    <v-row class="d-flex justify-center" >  

                        <template
                            v-for="(data,i) in howItWorks"                        
                        >
                            <v-col 
                                :key="i"
                                cols="12" 
                                sm="12"
                                md="2"                             
                                :style="{'marginTop' : $vuetify.breakpoint.mdAndUp ? '0px' : '16px'}"
                            >                        
                                <div style="position:relative;">
                                    <div class="justify-center d-flex flex-column">
                                        <div class="ma-auto" style="background:#fff;width:160px;z-index:2;">
                                            <v-img 

                                                class="ma-auto" 
                                                width="100"                      
                                                height="100"                     
                                                :aspect-ratio="1/1"                                                                
                                                :src="data.img"                                         
                                                style="z-index:2;"
                                            ></v-img>  
                                        </div>
                                        
                                        <div class="text-center rfont-16 weight-semibold darkergray2--text" v-html="data.title">                            
                                        </div>
                                    </div>                                
                                </div>
                            </v-col>      
                        </template>                                                 
                    </v-row>
                                        
                                        
                </div>  
                
            </v-container>
        </v-container>

        <v-container style="background:url('general/bg_download_app.png');background-size:100% 100%;background-position:center center;position:relative;"
            :style="$vuetify.breakpoint.smAndDown ? 'margin-top:60px' : 'margin-top:110px'"
        >
            <v-row>
                <v-col cols="12" sm="12" md="12" class="px-10 py-8">
                <h1 class="rfont-32 secondaryVariant--text playfair-display weight-semibold">Download HealthyAlways App</h1>                    
                    <h1  class="rfont-20 secondaryVariant--text playfair-display weight-semibold">Access India’s top doctors on the HealthyAlways app.<br>Books appointments with doctors 24/7 anywhere in the world.</h1>
                    <div class="mt-3">
                            
                                <v-img
                                    width="150"
                                    src="/general/download-android-v3.png"                                                                     
                                    @click="goToPatientApp()"                                    
                                    class="cursor-pointer"
                            />
                            
                        </div>
                </v-col>
            </v-row>
            <img v-if="$vuetify.breakpoint.mdAndUp" src="/general/img_doc.png" style="position:absolute;max-width:350px;right:0;bottom:0;" />
        </v-container>
        
        
        
        

<!--        Trending Care Web-->
        <v-container fluid class="mt-12" >
            <v-container class="">
                <v-row class="home-rows" align="center">
                    <v-col cols="12" sm="12" md="12" class="text-center">
                        <h1 class="rfont-32 darkergray--text playfair-display weight-semibold">Top Doctors</h1>                        
                    </v-col>
                    <v-col cols="12" sm="12" md="8" offset-md="2" class="text-center">
                        <h6 class="rfont-20 darkergray--text playfair-display weight-medium">Health is our greatest treasure and with incredible specialists you can choose a doctor for your perfect health.</h6>
                    </v-col>                                   
                </v-row>

                <v-row>

                    <v-col cols="12" class="text-center">                    
                        <v-carousel                     
                            v-model="topDoctorsObj.page"
                            height="auto" 
                            hide-delimiters
                            :show-arrows="topDoctorsObj.uiList.length >1 "
                        >
                            <template v-slot:prev="{ on, attrs }">
                                
                                <v-btn
                                v-bind="attrs"
                                    v-on="on"
                                color="white"
                                fab
                                x-small
                                dark
                                >
                                    <v-icon class="darkergray--text" >mdi-chevron-left</v-icon>
                                </v-btn>
                                </template>
                                <template v-slot:next="{ on, attrs }">
                                    <v-btn
                                    v-bind="attrs"
                                        v-on="on"
                                    color="white"
                                    fab
                                    x-small
                                    dark
                                    >
                                        <v-icon class="darkergray--text" >mdi-chevron-right</v-icon>
                                    </v-btn>
                                </template>
                                <v-carousel-item                                  
                                v-for="(subList,i1) in topDoctorsObj.uiList"                                
                                :key="i1"
                            >
                            
                                <v-row
                                    class="mx-10"                   
                                >
                                    <v-col 
                                        v-for="(care,i2) in subList"                                        
                                        :key="i2"
                                        :cols="topDoctorsObj.cols">
                                            <v-card                                                
                                                class="card-shadow-2 mx-1 mb-12 px-4 rounded-lg"
                                                style="margin-top:100px;"
                                                color="white"
                                                
                                            >
                                                <v-row>
                                                <v-col cols="12" class="d-flex justify-center pt-0" style="margin-top:-50px">
                                                        <v-responsive :aspect-ratio="1/1" style="max-width:120px;position:relative;" class="elevation-0 pa-2">
                                                            <v-responsive :aspect-ratio="1/1" class="rounded-circle elevation-3 d-flex justify-center align-center white">
                                                                <v-img     
                                                                    v-if="care.profile_image_path"
                                                                    :aspect-ratio="1/1"                                                                
                                                                    :src="getImagePath(care.profile_image_path)"                                                                                                                                
                                                                ></v-img>                                                            
                                                                <v-img     
                                                                    v-else
                                                                    :aspect-ratio="1/1"                                                                
                                                                    src="/general/profile_placeholder.svg"                                                                                                                                
                                                                ></v-img>  
                                                            </v-responsive>
                                                            <v-img width="22" :aspect-ratio="1/1" src="/general/ic_verified.png" max-width="24" style="position:absolute;bottom:10%;right:10%;"> </v-img>
                                                        </v-responsive>
                                                        
                                                        
                                                    </v-col>

                                                   
                                                    <v-col cols="12">
                                                        <div 
                                                            @click="showDoctorProfile(care)"
                                                            class="weight-bold secondaryVariant--text cursor-pointer"
                                                            v-bind:class="{'rfont-18' : care.name.length <= 12,'rfont-16': care.name.length >= 12}"
                                                        >                                                            
                                                               {{care.name}}
                                                         
                                                        </div>
                                                        <div 
                                                            class="weight-semibold mt-1"
                                                            style="color:#787878"
                                                            v-bind:class="{'rfont-18' : care.specializations[0].name.length <= 12,'rfont-14': care.specializations[0].name.length >= 12}"
                                                        >                                                            
                                                               {{care.specializations[0].name}}
                                                         
                                                        </div>
                                                        <div 
                                                            class="weight-regular mt-1 rfont-14"
                                                            style="color:#9B9B9B"                                                            
                                                        >                                                            
                                                               {{care.professional_exp}} years of experience
                                                         
                                                        </div>                                                        
                                                        
                                                        <div class="cursor-pointer weight-semibold rfont-14 primary--text d-flex justify-center align-center mt-4 mb-4" @click="goToSearchDoctorsFromTopDoctors(care)">
                                                            <span class="mr-1 cursor-pointer">Consult Now </span>
                                                            <v-icon small class="primary--text mx-0 px-0" style="width:8px">mdi-chevron-right</v-icon>
                                                            <v-icon small class="primary--text mx-0 px-0" style="width:8px">mdi-chevron-right</v-icon>
                                                        </div>
                                                    </v-col>
                                                </v-row>                                            
                                            </v-card>
                                    </v-col>
                                </v-row>
                            
                            </v-carousel-item>                                                        
                        </v-carousel>
                    </v-col>             
                    <v-col cols="12" class="mt-0 pt-0" align="center">
                        <v-btn color="#D7F6FD" flat class="secondaryVariant--text weight-semibold rfont-14  mb-2" large @click="$router.push({name: 'searchDoctor', query:{video:1}})">
                            View All
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>

        
        <v-container fluid class="pa-0 pb-6" style="background:#f6e9d4;"
            :style="$vuetify.breakpoint.mdAndUp ? 'margin-top:150px;' : 'margin-top:64px'"
        >
            <v-container>
                <v-row :style="$vuetify.breakpoint.mdAndUp ? 'margin-top:-100px;' : ''">
                    <v-col cols="12" md="4">
                        <v-card
                            style="width:100%"
                            color="#EAF4FF"
                            class="d-flex flex-column rounded px-8 py-6 card-shadow rounded-xl"                            
                        >                            
                            <div
                                class="d-flex align-center"
                                style="width:100%;"
                            >
                                <span style="width:70px;height:70px;" class="">
                                    <div style="width:100%;height:100%;background:#C8E2FF;border-radius:2000px;">
                                    <v-img
                                        style="top:50%;left:50%;transform:translate(-50%,-50%);"
                                        width="40"
                                        src="/general/ic_satisfied_customers.png"                                                                     
                                    ></v-img>
                                    </div>
                                    
                                </span>
                                                                                            
                            </div>        
                            
                             <div                                
                                    class="rfont-38 darkergray2--text weight-semibold mt-4"
                                >2000+</div>
                                <div                                
                                    class="rfont-18 darkergray2--text weight-semibold mt-n1"
                                >Satisfied customers</div>

                        </v-card>
                    </v-col>          

                    <v-col cols="12" md="4">
                        <v-card
                            style="width:100%"
                            color="#EFFFEF"
                            class="d-flex flex-column rounded px-8 py-6 card-shadow rounded-xl"                            
                        >                            
                            <div
                                class="d-flex align-center"
                                style="width:100%;"
                            >
                                <span style="width:70px;height:70px;" class="">
                                    <div style="width:100%;height:100%;background:#D0F2D0;border-radius:2000px;">
                                    <v-img
                                        style="top:50%;left:50%;transform:translate(-50%,-50%);"
                                        width="40"
                                        src="/general/ic_verified_doctors.png"                                                                     
                                    ></v-img>
                                    </div>
                                    
                                </span>
                                                                                            
                            </div>        
                            
                             <div                                
                                    class="rfont-38 darkergray2--text weight-semibold mt-4"
                                >500+</div>
                                <div                                
                                    class="rfont-18 darkergray2--text weight-semibold mt-n1"
                                >Verified Doctors</div>

                        </v-card>
                    </v-col>             

                    <v-col cols="12" md="4">
                        <v-card
                            style="width:100%"
                            color="#FFF6E8"
                            class="d-flex flex-column rounded px-8 py-6 card-shadow rounded-xl"                            
                        >                            
                            <div
                                class="d-flex align-center"
                                style="width:100%;"
                            >
                                <span style="width:70px;height:70px;" class="">
                                    <div style="width:100%;height:100%;background:#F6E7D0;border-radius:2000px;">
                                    <v-img
                                        style="top:50%;left:50%;transform:translate(-50%,-50%);"
                                        width="40"
                                        src="/general/ic_specialities.png"                                                                     
                                    ></v-img>
                                    </div>
                                    
                                </span>
                                                                                            
                            </div>        
                            
                             <div                                
                                    class="rfont-38 darkergray2--text weight-semibold mt-4"
                                >20+</div>
                                <div                                
                                    class="rfont-18 darkergray2--text weight-semibold mt-n1"
                                >Specialities</div>

                        </v-card>
                    </v-col>             

                </v-row>

                <v-row :style="$vuetify.breakpoint.mdAndUp ? 'margin-top:80px;' : 'margin-top:40px;'">
                    <v-col cols="12" md="6" v-if="$vuetify.breakpoint.mdAndUp">
                        <v-img                   
                            src="/general/benefits_img.png"                                                                     
                        ></v-img>                    
                    </v-col>

                    <v-col cols="12" md="6">
                        <h1 class="rfont-32 darkergray--text playfair-display weight-semibold">Benefits of online consultation</h1>                        
                        
                        <v-img                   
                            class="mt-3"
                            v-if="$vuetify.breakpoint.smAndDown"
                            src="/general/benefits_img.png"                                                                     
                        ></v-img>                    
                    
                        <v-expansion-panels accordion class="mt-4">
                            <v-expansion-panel                                          
                                    v-for="(benefit,i) in onlineBenefits"
                                    :key="i"
                                    class="mt-5 elevation-0"
                                    style="border-radius:6px;"
                            >
                                <v-expansion-panel-header class="secondaryVariant--text rfont-16 weight-medium">{{ benefit.title }}</v-expansion-panel-header>
                                <v-expansion-panel-content class="weight-regular darkergray--text rfont-16">
                                    <v-divider></v-divider>
                                    <div class="mt-4">
                                        {{benefit.desc}}
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                    
                </v-row>
            </v-container>
            
        </v-container>            
        

        <v-container class="mt-12">

            <v-row align="center">
                <v-col cols="12" sm="12" md="12" class="text-center">
                    <h1 class="rfont-32 darkergray--text playfair-display weight-semibold">What our users have to say</h1>                        
                </v-col>     
                <v-col cols="12" md="12" class="text-center">                    
                        <v-carousel                     
                            height="auto" 
                            hide-delimiter-background
                            v-model="testimonialsObj.page"                                                        
                            class="testimonial_carousel"
                            :show-arrows="$vuetify.breakpoint.smAndDown ? false : true"
                            
                        >
                            <template v-slot:prev="{ on, attrs }">
                                
                                <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    color="white"
                                    fab
                                    small
                                    dark
                                >
                                    <v-icon class="darkergray--text" >mdi-chevron-left</v-icon>
                                </v-btn>
                                </template>
                                <template v-slot:next="{ on, attrs }">
                                    <v-btn
                                    v-bind="attrs"
                                        v-on="on"
                                    color="white"
                                    fab
                                    small
                                    dark
                                    >
                                        <v-icon class="darkergray--text" >mdi-chevron-right</v-icon>
                                    </v-btn>
                                </template>
                            <v-carousel-item                                       
                                :style="{marginLeft: $vuetify.breakpoint.mdAndUp ? '80px' : '20px', marginRight: $vuetify.breakpoint.mdAndUp ? '80px' : '20px' }"
                                style="box-shadow:0px 3px 40px #ABABAB29;margin-bottom:60px;"
                                v-for="(testimonial,i1) in testimonialsObj.uiList"                                
                                :key="i1"
                                
                            >
                                                                                           
                                <v-row class="ma-0">                                                    
                                    <v-col cols="12" class="py-8 px-0" style="background:#fff; border-radius:20px;">
                                        <div 
                                            class="weight-medium darkergray--text rfont-16 text-justify px-8 py-2"
                                            style="line-height:1.8;"
                                        >                                                            
                                                {{testimonial.testimonial}}
                                            
                                        </div>
                                        <div 
                                            class="text-center weight-bold darkergray--text rfont-22 text-left px-8 mt-3"
                                            style="line-height:1.8;"
                                        >                                                            
                                                {{testimonial.name}}
                                            
                                        </div>
                                        <div 
                                            class="text-center font-italic weight-semibold darkergray--text rfont-14 text-left px-8"
                                            style="line-height:1.8;"
                                        >                                                            
                                                {{testimonial.position}}
                                            
                                        </div>
                                    </v-col>
                                </v-row>                                            
                                
                        
                            </v-carousel-item>
                            
                        </v-carousel>
                        
                    </v-col>                                                   
                    <v-col cols="12" class="justify-center d-flex" v-if="$vuetify.breakpoint.smAndDown">                        
                                
                        <v-btn
                            @click="testimonialsObj.page--"
                            v-bind="attrs"
                            v-on="on"
                            color="white"
                            fab
                            small
                            dark
                        >
                            <v-icon class="darkergray--text" >mdi-chevron-left</v-icon>
                        </v-btn>
                        
                            <v-btn
                                @click="testimonialsObj.page++"
                                class="ml-4"
                                v-bind="attrs"
                                v-on="on"
                                color="white"
                                fab
                                small
                                dark
                            >
                                <v-icon class="darkergray--text" >mdi-chevron-right</v-icon>
                            </v-btn>                                
                    </v-col>
            </v-row>
        </v-container>
        

        <v-container fluid class="mt-10">
            <v-container class="">
                <v-row align="center">
                    <v-col cols="12" sm="12" md="12" class="text-center">
                        <h1 class="rfont-32 darkergray--text playfair-display weight-semibold">FAQs</h1>  
                    </v-col>
                    <v-col cols="12" sm="12">
                    
                        <v-expansion-panels flat class="font-weight-medium" v-model="faqExpandedModel">
                            <v-expansion-panel 
                                style="background:transparent;"
                                v-for="(questionAnswer) in faqList"
                                :key="questionAnswer.question"
                                class="question-expansions"
                                
                            >
                            <!--
                            <v-expansion-panel-header
                                    class="darkergray--text rfont-18"
                                    :class="faqExpandedModel === i ? 'weight-semibold' : 'weight-regular'"
                                > 
                                -->
                                <v-expansion-panel-header
                                    class="secondaryVariant--text rfont-18 'weight-semibold"                                    
                                > 
                                    {{ questionAnswer.question }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content class="">
                                    <span class="weight-regular rfont-16 darkergray--text"
                                          v-html="questionAnswer.answer"></span>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                    <v-col>

                    <div style="text-decoration:underline;" class="ml-6 font-12 weight-medium text-left cursor-pointer" v-if="!viewMoreQuestions" @click="expand()">View More</div>
                    <div style="text-decoration:underline;" class="ml-6 font-12 weight-medium text-left cursor-pointer" v-if="viewMoreQuestions == true" @click="collapse(true)">View Less</div>
                    
                    
                    </v-col>

                </v-row>
            </v-container>
        </v-container>
        
         <v-container fluid class="pa-0 d-flex align-center" style="background:url('/general/app-down-bg-2.png');background-position:center center;position:relative; min-height:502px;" id="download_2">

            <v-container>
                <v-row>
                    <v-col cols="12" md="6" class="d-flex align-center">
                        <v-row no-gutters>
                            <v-col cols="12" md="12">
                                <h5 class="weight-bold font-24 darkergray--text">Download HealthyAlways App</h5>
                            </v-col>
                            <v-col cols="12" md="6" class="pl-0 ml-n2">
                                <v-list class="wrap-normal-list" style="background:transparent">
                                    <v-list-item                        
                                        class="pl-0"
                                        style="min-height:10px"
                                        v-for="(obj,i) in downloadAppObj.col1"
                                        :key="i"
                                    >
                                        <v-list-item-icon class="mr-3 my-0 align-self-center">
                                            <v-icon color="primaryVariant" rounded>mdi-chevron-right</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content class="my-0">
                                            <v-list-item-title class="darkergray--text rfont-16 weight-medium py-0">
                                                {{obj.desc}}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>         
                                    <template v-if="$vuetify.breakpoint.smAndDown"   >
                                            <v-list-item                     
                                        
                                                class="pl-0"
                                                style="min-height:10px"
                                                v-for="(obj,i) in downloadAppObj.col2"
                                                :key="i"
                                            >
                                                <v-list-item-icon class="mr-3 my-0 align-self-center">
                                                    <v-icon color="primaryVariant" rounded>mdi-chevron-right</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content class="my-0">
                                                    <v-list-item-title class="darkergray--text rfont-16 weight-medium py-0">
                                                        {{obj.desc}}
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>   
                                    </template>
                                                                                                
                                </v-list>
                            </v-col>

                            <v-col cols="12" md="6" class="ml-n2" v-if="$vuetify.breakpoint.mdAndUp">                    
                                <v-list class="wrap-normal-list" style="background:transparent">
                                    <v-list-item                        
                                        class="pl-0"
                                        style="min-height:10px"
                                        v-for="(obj,i) in downloadAppObj.col2"
                                        :key="i"
                                    >
                                        <v-list-item-icon class="mr-3 my-0 align-self-center">
                                            <v-icon color="primaryVariant" rounded>mdi-chevron-right</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content class="my-0">
                                            <v-list-item-title class="darkergray--text rfont-16 weight-medium py-0">
                                                {{obj.desc}}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>                                                                
                                </v-list>
                            </v-col>
                            <v-col cols="12" md="12" class=" mt-4">        
                                
                                <v-img
                                    width="150"
                                    src="/general/download-android-v3.png"                                                                     
                                    @click="goToPatientApp()"                                    
                                    class="cursor-pointer"
                                />
                                
                            </v-col>
                        </v-row> 
                    </v-col>
                    

                    
                </v-row>
       
            </v-container>

        </v-container>

       


        <!--        Convenience -->
        <v-container fluid class="lightBackground px-0" v-if="0===1">
            <v-container class="">
                <v-row style="min-height: 60vh" class="home-rows" align="center">
                    <v-col cols="12" sm="12" md="6">
                        <h1 class="font-32 playfair-display font-weight-bold">Convenience when you need it most.</h1>
                        <br>
                        <h2 class="font-weight-regular font-26 opacity-8">
                            Receive care at the comfort of your home.
                            Schedule in home lab tests.
                        </h2>

                        <br class="hidden-sm-and-down">
                        <br>
                        <h2 class="">
                            <v-btn class="accent white--text" rounded large ripple>
                                Schedule Lab Tests
                                <v-icon right> mdi-arrow-right</v-icon>
                            </v-btn>
                        </h2>
                    </v-col>
                    <v-col cols="12" sm="12" md="6" class="hidden-sm-and-down">
                        <!--                        <v-card flat>-->
                        <v-img src="../assets/home/banner-4.png" width="100%"></v-img>
                        <!--                        </v-card>-->
                    </v-col>
                </v-row>
            </v-container>
        </v-container>


    
       
        <!--        Articles -->
        <!-- <v-container fluid class="lightPinkBackground">
            <v-container class="">
                <v-row style="min-height: 60vh" class="home-rows" align="center">
                    <v-col cols="12" sm="12" md="12" class="text-center">
                        <h1 class="font-32 playfair-display font-weight-bold">The Latest from Healthy Always</h1>
                    </v-col>
                    <v-col cols="12" sm="12" md="3">
                        <v-card>
                            <v-img
                                    class="white--text align-end"
                                    height="200px"
                                    src="../assets/home/articles/teeth-sensitivity.jpg"
                            >
                            </v-img>

                            <v-card-title class="accent-gradient--text">Dental Hygiene</v-card-title>
                            <v-card-text class="text--primary">
                                <div>
                                    Common causes of teeth sensitivity. How to keep your teeth healthy!
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="12" md="3">
                        <v-card>
                            <v-img
                                    class="white--text align-end"
                                    height="200px"
                                    src="../assets/home/articles/keep-eyes-healthy.jpg"
                            >
                            </v-img>

                            <v-card-title class="accent-gradient--text font-weight-bold">Healthy Eyes</v-card-title>
                            <v-card-text class="text--primary">
                                <div>
                                    How to keep your sensitive eyes healthy and clean
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="12" md="3">
                        <v-card>
                            <v-img
                                    class="white--text align-end"
                                    height="200px"
                                    src="../assets/home/articles/joint-pain.jpg"
                            >
                            </v-img>

                            <v-card-title class="accent-gradient--text font-weight-bold">Joint Pain</v-card-title>
                            <v-card-text class="text--primary">
                                <div>
                                    Tips to get joint pain relief in this chilling winter
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="12" md="3">
                        <v-card>
                            <v-img
                                    class="white--text align-end"
                                    height="200px"
                                    src="../assets/home/articles/homeopathy-image.jpg"
                            >
                            </v-img>

                            <v-card-title class="accent-gradient--text font-weight-bold">Homeopathy</v-card-title>
                            <v-card-text class="text--primary">
                                <div>Homeopathy for common cold, cough and other issues</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container> -->

        <!-- app link -->
        
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'    
    export default {
        name: "Home",        
        computed: {
            ...mapGetters([          
                'userInfo'
            ]),
        },
        mounted() {
            var paramurl="http://localhost:8081/appointment-call/279e4a8a-eaca-4f97-a81d-88e05f60a978"
            var url = new URL("http://localhost:8080/")
            url.searchParams.set('redirect', paramurl);                        
            
            this.getTopDoctors()            
            this.collapse(false)
        },

        data() {
            return {
                
                block: 1,
                patient_app_link:process.env.VUE_APP_API_URL+"/app/patient",
                topDoctorsObj:{
                    page:0,
                    uiList:[],
                    originalList:[],
                    itemsPerPage:1,
                    cols:12
                },
                specialitiesObj:{
                    specialities:[],
                    originalSpecialitiesList:[],
                    itemsPerPage:0,
                    cols:6
                },
                
                testimonialsObj:{
                    page:0,
                    uiList:[
                        {
                            id:"1",
                            testimonial:"The best and easiest way to get consultation on phone/chat or video calls, this is very useful especially for the people who have busy work schedule. It saves money as well as our precious time and even helps us give more time through video consultations. No need to rush to the hospital every now and then Or we can say that your health is in your pocket now. Great idea!!",
                            name:"Aryan Khandelwal",
                            position:"General Manager",
                        },
                        {
                            id:"1",
                            testimonial:"I never review Apps, but this has been the quickest and most convenient doctor experience(s) I’ve ever had. It cost me no more than what I would have paid to visit a clinic. I’ve had two appointments and one was done in the comfort of my own living room and the second on my break at work. As a full time worker the convenience cannot be beaten. I met with a Doctor who is very personable and kind. He immediately resolved my reasons for calling during both appointments. He was competent and trustworthy and valued my time. Can’t recommend this enough.",
                            name:"Krutika Vartak",
                            position:"Executive Assistant",
                        },
                        {
                            id:"1",
                            testimonial:"My Virtual Appointment was the best it could be. The site is user friendly and set up easily for anyone to navigate. It ran smoothly and the doctor was very attentive and helpful.",
                            name:"Ranjan Patel",
                            position:"Vice President",
                        },
                        
                    ],                    
                    itemsPerPage:1,
                    cols:12
                },
                
                downloadAppObj:{
                    col1:[
                        {
                            desc:"Book appointments"
                        },
                        {
                            desc:"Order medicines"
                        },
                        {
                            desc:"Consult doctors online"
                        },
                    ],
                    col2:[
                        {
                            desc:"Set medicine reminders"
                        },
                        {
                            desc:"Store health records"
                        },
                        {
                            desc:"Read health tips"
                        },
                    ],
                },
                                
                onlineBenefits:[
                    {
                        title:"Consult top doctors 24/7",
                        desc:"We have more than 500 certified doctors who are available for video consultations as per your convinience."
                    },
                    {
                        title:"Convenient and easy",
                        desc:"Select the speaciality followed by the doctor from your mobile device or computer and your done. Its that easy!"
                    },
                    {
                        title:"100% safe consultations",
                        desc:"HealthyAlways is HIPAA compliant. So there isnt any need to be worried for Privacy and Security as everything is safe with us."
                    },
                    {
                        title:"Similar clinic experience",
                        desc:"Consultations with doctor are much more safer and easier as you can consult doctor from your very own place anytime."
                    },
                    {
                        title:"Ask free questions",
                        desc:"Get answers to your questions from a certified doctor or healthcare professional without any cost."
                    }
                ],
                faqExpandedModel:"",
                viewMoreQuestions:false,
                faqList:[],
                originalFaqList:[
                    {
                        question:"How can I be sure that this is an effective form of consultation?",
                        answer:"Our confidence in the platform comes primarily from the feedback and testimonials we receive from users. Every day we are excited to hear from more people about the way this service helped them make a tremendous change in their lives."
                    },
                    {
                        question:"How does using video consultation help patients?",
                        answer:"It gives patients the convenience to contact their own specialist for a clarification or routine follow-up review without need to travel. It provides the opportunity to keep in touch with their specialist when patients move further away due to work commitments or otherwise. It enables the patient to connect to specialists for a second opinion which otherwise would have been extremely difficult (for example, specialists based outside India)."
                    },
                    {
                        question:"How do live video sessions work?",
                        answer:"To talk on a video consultation, you will need to book an appointment with your counsellor and select a time slot for the same. Your counsellor will then prompt you to start the video session. After you confirm, you will immediately begin video chatting with your Doctor."
                    },
                    {
                        question:"What are the service timings?",
                        answer:"Our doctors are available 24/7. However all times you can contact our support team care@healthyalways.com under support chat section if you need further assistance."
                    },                    
                    {
                        question:"Why isn’t HealthyAlways free?",
                        answer:"Our app is free to download. The price you pay is for your individual visit and is used to cover the cost of the consultation time."
                    },
                    {
                        question:"Can I speak with the same doctor again?",
                        answer:"Yes. All your consultations are stored separately and can be viewed from Dashboard. You can continue talking to the same doctor by selecting respective Doctor from Doctor Search. In case your consultation gets over and you need to consult the same doctor again, you can do so by paying the consultation for a new session with the same doctor. They will have your chat history as well as any reports or images that you had attached earlier."
                    },
                    {
                        question:"What can I ask the doctor?",
                        answer:"All questions related to Medical Field. Our doctors help with, fevers, colds, weight and a whole lot more. We do not answer general questions that are not directly related to your health (How to make green tea? What is a good career choice?)"
                    },
                    {
                        question:"How much does it cost?",
                        answer:"Our consultation fees are much more reasonable than clinic rates. You can save lots by consulting India’s top doctors through HealthyAlways. Adding the savings of NOT travelling in traffic and waiting for appointments can save a lot."
                    },
                    {
                        question:"What payment methods do we accept?",
                        answer:"We accept the following payment methods: All major Credit cards, such as VISA, MasterCard, American Express and Discover. Paypal, UPI and Net Banking."
                    },
                    {
                        question:"How long does a consultation last?",
                        answer:"Each consultation is expected to last around 10-15 minutes. However, The actual duration of the video consultation will depend on the Doctor's assessment of the patients condition."
                    },
                    {
                        question:"Can I choose my own Doctor?",
                        answer:"Yes you can choose your own doctor from the speciality tab which will be seen before asking the question."
                    },
                    {
                        question:"What happens if the video call gets disconnected in between?",
                        answer:"You shall be provided with an option to reconnect in such case."
                    },
                    {
                        question:"What do I do if I am not available during the booked appointment?",
                        answer:"You have an option to reschedule it."
                    },
                    {
                        question:"Will I get refund if I am not able to connect to the doctor after payment?",
                        answer:"Yes, If you are not able to connect to the session due to any technical reasons."
                    },
                    {
                        question:"How many days will the refund process take?",
                        answer:"It will take 7-10 business days"
                    },
                    {
                        question:"I want to talk to someone at HealthyAlways",
                        answer:"Please mail us at care@healthyalways.com"
                    },
                    {                        
                        question:"How can I get started with HealthyAlways?",
                        answer:`<a class='c7' href='${this.getLoginLink()}'>Click here to get started</a>`
                    }                    

                ],
                howItWorks:[
                    {
                        img:"/general/ic_select_speciality.png",
                        title:"Select a speciality"
                    },
                    {
                        img:"/general/ic_select_doc.png",
                        title:"Choose a doctor from 1000 of verified doctors"
                    },
                    {
                        img:"/general/ic_make_payment.png",
                        title:"Make Payment Online"
                    },
                    {
                        img:"/general/ic_consult_online.png",
                        title:"Video Consult online"
                    },
                    {
                        img:"/general/ic_digital_prescription.png",
                        title:"Get a digital<br>prescription"
                    }
                ]
            }
        },
        watch:{
            "$vuetify.breakpoint.name":function(){                                     
                this.updateTopDoctorsUiData()
            },
            
        },
        methods: {
            getLoginLink(){
                return process.env.VUE_APP_URL+"/patient-login"
            },
            expand(){
                this.viewMoreQuestions = true
                this.updateQuestionsList()
            },
            collapse(scroll_down){
                this.viewMoreQuestions = false
                this.updateQuestionsList()
                if(scroll_down)
                    document.getElementById('download_2').scrollIntoView();
            },
            updateQuestionsList(){
                if(this.viewMoreQuestions){
                    this.faqList = this.originalFaqList
                }else{
                    this.faqList = this.originalFaqList.slice(0,5)
                    
                }
            },
            getMargin(index){
                var size = this.howItWorks.length                
                var offset = 30;
                var mid = (size / 2)
                var margin = index * size
                if(index <= mid)
                    margin = offset * index
                else
                    margin = offset * ( size -1 - index)
                return margin
            },
            isStrEmpty(str) {
                return (!str || 0 === str.length);
            },            
                        
            goToPatientApp(){
                window.open(process.env.VUE_APP_API_URL+"/app/patient",)
            },
            getTopDoctors() {
                
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/doctors/top-video-doctors`)
                .then((response) => {
                    if(response.data.status == 1){                                                  
                     this.topDoctorsObj.originalList = response.data.data
                     this.updateTopDoctorsUiData()
                    }                    
                    
                }).catch((error) => {
                    console.log(error)
                })
                .finally(() => {
                    
                })
            },
            updateTopDoctorsUiData(){
                var itemsPerPage = 0
                
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs': itemsPerPage = 1; break;
                    case 'sm': itemsPerPage = 2; break;
                    case 'md': itemsPerPage = 4; break;
                    case 'lg': itemsPerPage = 4; break;
                    case 'xl': itemsPerPage = 4; break;
                }
                this.topDoctorsObj.itemsPerPage = itemsPerPage

                this.topDoctorsObj.cols = 12 / itemsPerPage
                
                var list = []                
                
                var totalPages = this.topDoctorsObj.originalList.length / itemsPerPage
                var isOver = false

                for(var i=0 ; i < totalPages; i++){
                    var subList = []
                    for(var j=0; j < itemsPerPage; j++){
                        var index = (i * itemsPerPage) + j                
                        if(index == this.topDoctorsObj.originalList.length){                            
                            isOver = true
                            break
                        }                                                    
                        
                        subList.push(this.topDoctorsObj.originalList[index])                        
                        
                    }
                    if(subList.length)
                        list.push(subList)                    

                    if(isOver)
                        break
                    
                }                
                this.topDoctorsObj.uiList = list
                
            },                  
          
          
            letsGetStarted(){
                // this.$router.push({name: 'askAQuestion'})
                if(this.userInfo)
                    this.$router.push({name: 'searchDoctor', query:{video:1}})
                else
                    this.$router.push({name: 'patientLogin'})                    

            },
           
            goToSearchDoctorsFromTopDoctors(data_obj){                
                    var obj = {
                        searchString:data_obj.name,
                        group:"Doctors",
                        id:data_obj.id,
                    }                    
                    this.$router.push({name: 'searchDoctor',query:{ doctorOrSpeciality: JSON.stringify(obj),video:1 }})
            }
        }
    }
</script>

<style scoped>
    .question-expansions {
        border-bottom: 1px solid #ccc !important;
        border-color: #ccc !important;
    }
    .banner-cards {
        border: 3px solid #E9C68E !important;
    }

    .banner-cards .v-card__actions {
        padding: 4px 8px !important;
        border-radius: 0 !important;
    }

    .action-cards {
        box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        overflow: hidden;
    }

    .action-cards:hover {
        box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.2);
    }

    .trending-button-active::after {
        content: " ";
        position: absolute;
        left: 48%;
        bottom: -40px;
        border-top: 0px solid #f6f3f1;
        border-right: 12px solid transparent;
        border-bottom: 20px solid #f6f3f1;
        border-left: 13px solid transparent;
        -webkit-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
        transform: translateX(-50%);
        opacity: 1;
        transition: all .4s;
    }

</style>